import { Controller } from '@hotwired/stimulus'

import MorphReconnect from '../../javascript/mixins/morph_reconnect'

export default class extends MorphReconnect(Controller) {
  static targets = ['track']
  static values = {
    speed: { type: Number, default: 1 }
  }

  connect () {
    this.position = 0
    this.animationId = null
    this.isAnimating = false
    this.isPaused = false

    const computedStyle = window.getComputedStyle(this.trackTarget)
    this.gap = parseFloat(computedStyle.gap) || 0
    this.totalContentWidth = 0
    Array.from(this.trackTarget.children).forEach(child => { this.totalContentWidth += child.offsetWidth + this.gap })

    this.checkWidth()
  }

  disconnect () {
    this.stopAnimation()
  }

  checkWidth () {
    if (this.totalContentWidth > this.element.clientWidth) {
      if (!this.isAnimating) { this.startAnimation() }
    } else {
      if (this.isAnimating) { this.stopAnimation() }
    }
  }

  startAnimation () {
    this.trackTarget.classList.replace('justify-center', 'justify-start')

    this.isAnimating = true
    this.animate()
  }

  stopAnimation () {
    this.isAnimating = false
    // eslint-disable-next-line no-undef
    if (this.animationId) { cancelAnimationFrame(this.animationId) }
    this.position = 0
    this.trackTarget.style.transform = 'translateX(0px)'

    this.trackTarget.classList.replace('justify-start', 'justify-center')
  }

  pause () { this.isPaused = true }
  resume () { this.isPaused = false }

  animate () {
    if (!this.isAnimating) return
    if (!this.isPaused) {
      this.position += this.speedValue

      const firstChild = this.trackTarget.firstElementChild
      const itemWidth = firstChild.offsetWidth + this.gap

      if (this.position >= itemWidth) {
        this.position -= itemWidth
        this.trackTarget.appendChild(firstChild)
      }

      this.trackTarget.style.transform = `translateX(-${this.position}px)`
    }

    // eslint-disable-next-line no-undef
    this.animationId = requestAnimationFrame(() => this.animate())
  }
}
